import { Injectable } from '@angular/core';
import { DefineBootboxId } from '../classes';

type imagem = { arquivo: string, alt: string };
@Injectable()
export class AvisoService {
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor() { }

  public alerta(pathImagem: imagem) {
    const mensagem = `<div class='img-responsive centralizar'>
    <img src='assets/img/avisos/` + pathImagem.arquivo + `' class="centralizar" alt="` + pathImagem.alt + `">
  </div>`;
    this.bootboxAlertComId.alerta(mensagem);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/aviso.service.ts